













import { Component, Vue } from "vue-property-decorator";
import PatientEditor from "@/components/Patient/PatientEditor.vue";

@Component({
  components: {
    PatientEditor,
  }
})
export class PatientCreate extends Vue {
}

export default PatientCreate;
